import { render, staticRenderFns } from "./industryManagement.vue?vue&type=template&id=71bad956&scoped=true"
import script from "./industryManagement.vue?vue&type=script&lang=js"
export * from "./industryManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bad956",
  null
  
)

export default component.exports